export default ">> **In order to integrate self-hosted Taiga with LambdaTest, enter your taiga-host, username and password.**";